import { useIntl } from 'react-intl';

import {
  IconCompanies,
  IconCompaniesFilled,
  IconContacts,
  IconContactsFilled,
  IconJobs,
  IconJobsFilled,
  IconNews,
  IconNewsFilled,
  IconSearch,
  IconSearchFilled,
} from '@xing-com/icons';
import { ProductsMenuWithItemsLoggedOut } from '@xing-com/platform-layout-products-menu';

import { ActivityCenterButton } from './activity-center-button/activity-center-button';
import {
  StyledOnlyOnBigScreenContainer,
  ActionButtonSpace,
} from './header.styles';
import { LoginButton } from './login-button/login-button';
import { NavItemHeader } from './nav-item-header';

export const HeaderNavItemsLoggedOut: React.FC<{
  loginLink?: string;
}> = ({ loginLink }) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <StyledOnlyOnBigScreenContainer>
        <NavItemHeader
          activeItemValues={['jobs']}
          icon={IconJobs}
          activeIcon={IconJobsFilled}
          title={formatMessage({ id: 'MAINNAV_JOBS_FIND' })}
          href="https://www.xing.com/"
          tracking={{
            nwt_nav: 'find_jobs',
          }}
        />
        <NavItemHeader
          activeItemValues={['companies']}
          icon={IconCompanies}
          activeIcon={IconCompaniesFilled}
          title={formatMessage({ id: 'MAINNAV_COMPANIES' })}
          href="https://www.xing.com/companies"
          tracking={{
            nwt_nav: 'companies',
          }}
        />
        <NavItemHeader
          icon={IconContacts}
          activeIcon={IconContactsFilled}
          title={formatMessage({ id: 'MAINNAV_NETWORK' })}
          href="https://www.xing.com/network"
          activeItemValues={['members']}
          tracking={{
            nwt_nav: 'network',
          }}
        />
        <NavItemHeader
          icon={IconNews}
          activeIcon={IconNewsFilled}
          title={formatMessage({ id: 'MAINNAV_INSIGHTS' })}
          href="https://www.xing.com/insights"
          activeItemValues={['insights']}
          tracking={{
            nwt_nav: 'insights',
          }}
        />
        <NavItemHeader
          icon={IconSearch}
          activeIcon={IconSearchFilled}
          title={formatMessage({ id: 'FRAME_HEADER_SEARCH' })}
          href="https://www.xing.com/jobs/search/ki"
          activeItemValues={['job-search']}
          tracking={{
            nwt_nav: 'job_search',
          }}
        />
      </StyledOnlyOnBigScreenContainer>
      <ActivityCenterButton
        title={formatMessage({ id: 'MAINNAV_ACTIVITY_CENTER' })}
        href="https://www.xing.com/activity"
      />
      <ActionButtonSpace>
        <LoginButton loginLink={loginLink} />
      </ActionButtonSpace>
      <StyledOnlyOnBigScreenContainer>
        <ProductsMenuWithItemsLoggedOut />
      </StyledOnlyOnBigScreenContainer>
    </>
  );
};
